import { NgModule } from '@angular/core';
import { RouteUtilService } from '../utils/route-util.service';
import { ToastService } from '../utils/toast.service';
import { ToastrModule } from 'ngx-toastr';
import { DirectivesModule } from './directives.module';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/modules/material.module';


@NgModule({
  
  imports: [
    ToastrModule.forRoot(),
    DirectivesModule,
    MaterialModule
  ],
  exports: [
    DirectivesModule,
    MatDialogModule
  ],
  providers: [
    {
      provide: MatDialogRef,
      useValue: {}
    },
    RouteUtilService,
    ToastService,
  ]
})
export class SharedModule {}
